import { useEffect } from "react";
import { scroll2Top } from "../../utils/utils";
import REEndBloc from "../../blocs/retirement/end/REEndBloc";

export default function REEndPage() {

  useEffect(() => {scroll2Top();}, []);

    return (
        <section className="bg-glace p-y-xl entreprise-container ">
            <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
                <REEndBloc/>
            </div>
        </section>
    )

}